<template>
  <div
    class="item-loading line"
    :style="{
      width: width + '%',
      height: height + 'px',
      margin: vSpace + 'px ' + hSpace + 'px'
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "fakeLine",
  props: {
    // height: {
    //   type: String,
    //   default: '15',
    // }
    width: String,
    vSpace: {
      type: String,
      default: "4"
    },
    hSpace: {
      type: String,
      default: "0"
    },
    height: {
      type: String,
      default: "12"
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.line {
  margin: 4px 0;
  padding: 0 !important;
  &:before,
  &:after {
    display: none;
  }
}
</style>
